


















import Vue from 'vue';
import { ClickRecipient } from '@/types';
import InputResultFilter from '@/components/pagination/InputResultFilter.vue';
import CampaignRecipientsTable from './CampaignRecipientsTable.vue';

export default Vue.extend({
  props: {
    clicks: {
      type: Array as () => ClickRecipient[],
      required: true,
    },
  },
  data() {
    return {
      maxResults: 10,
    };
  },
  computed: {
    filtered(): ClickRecipient[] {
      return this.clicks.slice(0, this.maxResults);
    },
  },
  components: {
    'input-result-filter': InputResultFilter,
    'campaign-recipients-table': CampaignRecipientsTable,
  },
});
